import uploadsnewspagebannerArticlebgimageshutterstock_2243996415CroppedJpg from "$lib/data/generated/uploads/news/PageBanner Article/bgImage/shutterstock_2243996415-cropped.jpg";

export const uploads = {
  "uploads/news/PageBanner Article/bgImage/shutterstock_2243996415-cropped.jpg": uploadsnewspagebannerArticlebgimageshutterstock_2243996415CroppedJpg
};